import axios from "../axiosConfig";
import store from "../store";
import { tokenConfig } from "./auth";

export const getPaymentUrl = async () => {
  const response = await axios.post("/redsys/", {}, tokenConfig(store.getState));

  return response.data;
};

export const checkPaymentStatus = async (id_pedido) => {
  const response = await axios.post("/redsys/check_payment_status/", { id_pedido }, tokenConfig(store.getState));

  return response.data;
};
